module.exports = __webpack_public_path__ + "static/media/about.5e520e8f.png";